import * as Icon from "react-feather";

let STATUS_CONFIG = {
	blocked:           { icon: Icon.AlertTriangle, color: "#b8860b" },
	waiting_for_human: { icon: Icon.User,          color: "#7b1fa2" },
	ready_to_propose:  { icon: Icon.FileText,      color: "#2e7d32" },
	waiting_for_agent: { icon: Icon.Clock,         color: "#1565c0" },
	not_started:       { icon: Icon.Circle,        color: "#ccc" },
};

function getStepStatusConfig(status) {
	return STATUS_CONFIG[status] || STATUS_CONFIG.not_started;
}

function getStepStatusClass(status) {
	if (status === "blocked") return "afs-review__exec-step--blocked";
	if (status === "waiting_for_human") return "afs-review__exec-step--waiting-human";
	if (status === "waiting_for_agent") return "afs-review__exec-step--waiting-agent";
	if (status === "ready_to_propose") return "afs-review__exec-step--ready";
	return "";
}

export { getStepStatusConfig, getStepStatusClass };
